import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from '../../components/hooks/LanguageContext'; // <-- хук

const Metrics = () => {
    const { language } = useLanguage();

    const metricsContent = {
        ru: [
            { value: "5+", text: "Гибких решений", isActive: true },
            { value: "100%", text: "Актуальность данных", isActive: false },
            { value: "10 лет", text: "Исторических данных", isActive: false }
        ],
        en: [
            { value: "5+", text: "Flexible Solutions", isActive: true },
            { value: "100%", text: "Accurate Data", isActive: false },
            { value: "10 Years", text: "of Historical Insights", isActive: false }
        ]
    };

    const metrics = metricsContent[language];

    const variants = {
        hidden: { opacity: 0, x: 100 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.6,
                type: "spring",
                stiffness: 50
            }
        })
    };

    return (
        <section data-bs-version="5.1" className="features10 cid-uB0EGy2TNO" id="metrics-2-uB0EGy2TNO">
            <div className="container">
                <div className="row justify-content-center">
                    {metrics.map((item, index) => (
                        <motion.div
                            key={index}
                            className={`item features-without-image col-12 col-md-6 col-lg-4 ${item.isActive ? "active" : ""}`}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                            custom={index}
                            variants={variants}
                        >
                            <div className="item-wrapper">
                                <div className="card-box align-left">
                                    <p className="card-title mbr-fonts-style mb-3 display-2">
                                        <strong>{item.value}</strong>
                                    </p>
                                    <p className="card-text mbr-fonts-style mb-3 display-7">
                                        {item.text}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Metrics;
